module.exports = __webpack_public_path__ + "pdf-lock.png?86a8a17ee6e5e870ee2600b3f0fb2096";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/attachment-format/pdf-lock.png
// module id = 38
// module chunks = 0